export enum CollaboratorTypeEnum {
  WAITING_CREATION = "WAITING_CREATION",
  CREATED = "CREATED",
}
